import * as CONSTANTS from '../constants/constants';
import { CLOUD_FUNCTION } from "../../../config/fbConfig"
import Axios from 'axios';
import cryptoRandomString from 'crypto-random-string'

export const signUp = newUser => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_AUTH });
  const firebase = getFirebase();
  const firestore = getFirestore();
  // eslint-disable-next-line no-whitespace-before-property
  firebase
    .auth()
    .createUserWithEmailAndPassword(newUser.email, newUser.password)
    .then(response => {
      firestore
        .collection('users')
      .doc(response.user.uid)
      .set({
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        email: newUser.email,
        plan: newUser.plan ? newUser.plan : "free",
        fullName: `${newUser.firstName} ${newUser.lastName}`,
        initials: newUser.firstName[0] + newUser.lastName[0],
        uid: response.user.uid,
        role: newUser.role,
        current_period_end: newUser.current_period_end,
        subscription: newUser.subscription,
        trial: {},
        status: newUser.status,
        emailConfirmed: false
      })
      .then(() => {
        if (newUser.card.id) {
          firestore.collection('users').doc(response.user.uid)
            .collection('cards').add(newUser.card)
            .then(() => console.log("payment card added"))
            .catch((err) => console.log(err))
          const { tap } = window
          tap('conversion', response.user.uid, newUser.plan === "pro" ? 250 : 50, {}, newUser.plan == "basic" ? "basic-plan" : "pro-plan");
        }
        if (newUser.paymentTokenID) {
          firestore.collection("paymentTokens")
            .doc(newUser.paymentTokenID).delete().then(() => {
              console.log("token redeemed")
            });
        }
        Axios.post(`${CLOUD_FUNCTION}/api/signupEmail`, { email: newUser.email, uid:response.user.uid }).then((suc) => console.log("Confirmation email sent"))

        dispatch({ type: CONSTANTS.SIGNUP_SUCCESS });
        dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
      })
    }
    ).catch((error) => {
      console.log(error)
      dispatch({ type: CONSTANTS.SIGNUP_ERROR, payload: error.message });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    });

};

export const signIn = credentials => (dispatch, getState, { getFirebase }) => {
  dispatch({ type: CONSTANTS.SET_LOADING_AUTH });

  const firebase = getFirebase();

  firebase
    .auth()
    .signInWithEmailAndPassword(credentials.email, credentials.password)
    .then(() => {
      dispatch({ type: CONSTANTS.LOGIN_SUCCESS });
    })
    .catch((error) => {
      dispatch({ type: CONSTANTS.LOGIN_ERROR, payload: error.message, loading: false });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    });
};

export const signOut = () => (dispatch, getState, { getFirebase }) => {
  const firebase = getFirebase();

  firebase
    .auth()
    .signOut()
    .then(() => {
      window.localStorage.clear();
      dispatch({ type: CONSTANTS.GET_MYCOURSES, courses: [] });
      dispatch({ type: CONSTANTS.SIGNOUT_SUCCESS });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
      dispatch({ type: CONSTANTS.RESET_SIGNOUT_SUCCESS_MSG });
      dispatch({ type: CONSTANTS.CLEAR_LAST_VIEW_COURSE });
    });
};
export const verifyUser = (token) => (dispatch, getState, { getFirebase }) => {
  Axios.post(`${CLOUD_FUNCTION}/api/verifyUser`,{token})
  .then((data)=>console.log(data))
};
export const saveToken = (token) => (dispatch, getState, { getFirestore }) => {
  const firestore = getFirestore();
  firestore.collection("paymentTokens").add({
    token: token,
  }).then((docRef) => {

    dispatch({ type: CONSTANTS.SAVE_TOKEN, payload: docRef.id })

    //TOKEN SAVED
  }).catch((err) => console.log(err))
}

export const getPaymentToken = (paymentTokenID) => (dispatch, getState, { getFirestore }) => {
  const firestore = getFirestore();
  firestore.collection("paymentTokens").doc(paymentTokenID).get().then((snapShot) => {
    dispatch({ type: CONSTANTS.GET_PAYMENT_TOKEN, payload: Object.assign(snapShot.data(), { id: snapShot.id }) })
    //TOKEN SAVED
  }).catch((err) => console.log(err))
}

export const resetEmail = credentilas => (
  dispatch,
  getState,
  { getFirebase }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_AUTH });

  const firebase = getFirebase();
  const user = firebase.auth().currentUser;

  const reauthenticate = (currentPassword) => {
    const cred = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    return user.reauthenticateAndRetrieveDataWithCredential(cred);
  };

  reauthenticate(credentilas.currentPassword)
    .then(() => {
      user
        .updateEmail(credentilas.email)
        .then(() => {
          dispatch({ type: CONSTANTS.RESET_EMAIL_SUCCESS });
          dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
        })
        .catch((error) => {
          dispatch({ type: CONSTANTS.RESET_EMAIL_ERROR, payload: error.message });
          dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
        });
    })
    .catch((error) => {
      dispatch({ type: CONSTANTS.REAUTH_ERROR_MSG, payload: error.message });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    });
};

export const sendEmailVerification = credentilas => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();
  const user = firebase.auth().currentUser;
  const emailTokens = []
  const emailTokensRef = firestore.collection
    (CONSTANTS.EMAIL_TOKENS);
  const emailTokenData = {
    email: user.email,
    token: cryptoRandomString({ length: 15 })
  }
  emailTokensRef.get().then((querySnapshot) => {
    querySnapshot.forEach((emailToken) => {
      emailTokens.push(Object.assign(emailToken.data(), { id: emailToken.id }));
    });
    var checkemailTokens = []
    checkemailTokens = emailTokens.filter((emailToken) => {
      return emailToken.email === user.email
    })
    if (!checkemailTokens.length) {
      emailTokensRef.add(emailTokenData)
        .then((docRef) => {
          console.log('done done')
          Axios.post(`${CLOUD_FUNCTION}/api/signupEmail`, { email: 'bellohargbola13@gmail.com' }).then((suc) => console.log("Confirmation email sent"))
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      emailTokensRef.doc(checkemailTokens[0].id).update({
        token: cryptoRandomString({ length: 15 })
      }).then((data) => {
        console.log('done updated')
        Axios.post(`${CLOUD_FUNCTION}/api/signupEmail`, { email: 'bellohargbola13@gmail.com' }).then((suc) => console.log("Confirmation email sent"))
      }).catch((err) => {
        console.log('error', err)
      })
    }
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const changePassword = credentilas => (
  dispatch,
  getState,
  { getFirebase }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_AUTH });

  const firebase = getFirebase();
  const user = firebase.auth().currentUser;

  const reauthenticate = (currentPassword) => {
    const cred = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    return user.reauthenticateAndRetrieveDataWithCredential(cred);
  };

  reauthenticate(credentilas.currentPassword)
    .then(() => {
      user
        .updatePassword(credentilas.newPassword)
        .then(() => {
          dispatch({ type: CONSTANTS.RESET_PASSWORD_SUCCESS });
          dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
        })
        .catch((error) => {
          dispatch({ type: CONSTANTS.RESET_PASSWORD_ERROR, payload: error.message });
          dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
        });
    })
    .catch((error) => {
      dispatch({ type: CONSTANTS.REAUTH_ERROR_MSG, payload: error.message });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    });
};
export const resetPassword = credentials => (
  dispatch,
  getState,
  { getFirebase }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_AUTH });

  const firebase = getFirebase();
  firebase.auth().verifyPasswordResetCode(credentials.oobCode)
    .then(() => {
      firebase.auth().confirmPasswordReset(credentials.oobCode, credentials.newPassword)
        .then(() => {
          dispatch({ type: CONSTANTS.RESET_PASSWORD_SUCCESS });
          dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
        }).catch((error) => {
          dispatch({ type: CONSTANTS.RESET_PASSWORD_ERROR, payload: error.message });
          dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
        })
    })
    .catch((error) => {
      dispatch({ type: CONSTANTS.RESET_PASSWORD_ERROR, payload: error.message });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    });
};
export const sendPassResetEmail = email => (
  dispatch,
  getState,
  { getFirebase }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_AUTH });
  const firebase = getFirebase();
  firebase.auth().sendPasswordResetEmail(email)
    .then(() => {
      dispatch({ type: CONSTANTS.RESET_PASSWORD_SUCCESS });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    })
    .catch((error) => {
      dispatch({ type: CONSTANTS.RESET_PASSWORD_ERROR, payload: error.message });
      dispatch({ type: CONSTANTS.RESET_AUTH_MSG });
    });
};

export const signUpFlow = (userId, data) => (
  dispatch, getState, { getFirestore }
) => {

  const firestore = getFirestore();
  const userRef = firestore.collection('users').doc(userId)
  userRef.update(data).then(() => {
    if (data.card.id) {
      firestore.collection('users').doc(userId)
        .collection('cards').add(data.card)
        .then(() => console.log("payment card added"))
        .catch((err) => console.log(err))
    }

  })
    .catch((err) => {
      console.log(err)
    })
}

export const changePlan = (userId, data) => (
  dispatch, getState, { getFirestore }
) => {

  const firestore = getFirestore();
  const userRef = firestore.collection('users').doc(userId)


  userRef.update(data).then(() => {
    dispatch({ type: CONSTANTS.CHANGE_PLAN })
    dispatch({ type: CONSTANTS.CLEAR_PLAN_MESSAGE })
  })
    .catch((err) => {
      console.log(err)
    })
}

export const saveCard = (userId, card, customerId = null) => (dispatch, getState, { getFirestore }) => {
  const firestore = getFirestore();
  const userRef = firestore.collection("users").doc(userId);
  if (customerId) {
    userRef.update({ subscription: { customerId } }).then(() => console.log('Customer created'))
  }
  userRef.collection('cards').add(card)
    .then((docRef) => {
      console.log("Card saved successfully")
      dispatch({ type: CONSTANTS.SAVED_CARD_SUCCESS })
      dispatch({ type: CONSTANTS.CLEAR_SAVED_CARD_MESSAGE })
      //CARD SAVED
    }).catch((err) => console.log(err))
}

export const getCards = (userId) => (dispatch, getState, { getFirestore }) => {
  const firestore = getFirestore();
  var cards = []
  firestore.collection("users").doc(userId)
    .collection('cards').get()
    .then((querySnapshot) => {
      querySnapshot.forEach((card) => {
        cards.push(Object.assign(card.data(), { uid: card.id }));
      });
      dispatch({ type: CONSTANTS.GET_USER_CARDS, payload: cards })

    }).catch((err) => console.log(err))
}

export const removeCard = (userId, cardId) => (dispatch, getState, { getFirestore }) => {
  const firestore = getFirestore();
  var cards = []
  firestore.collection("users").doc(userId)
    .collection('cards').doc(cardId).delete()
    .then(() => {
      console.log("Card deleted")
      dispatch({ type: CONSTANTS.REMOVED_USER_CARDS_SUCCESS })
      dispatch({ type: CONSTANTS.CLEAR_REMOVED_USER_CARDS_SUCCESS })
    }).catch((err) => console.log(err))
}

export const deleteUser = (userId) => (dispatch, getState, { getFirestore }) => {
  const firestore = getFirestore();
  firestore.collection("users").doc(userId).delete()
    .then(() => {
      dispatch({ type: CONSTANTS.DELETE_USER })
      dispatch({ type: CONSTANTS.CLEAR_DELETE_USER })
    })
    .catch((err) => console.log(err))
}

